import TransactionWelCard from "src/components/transactionWelCard/TransactionWelCard";
import styles from "./Group.module.scss";
import { Button, TablePagination } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Table from "rc-table";
import { useSearchParams } from "react-router-dom";
import { LIMIT, PAGE } from "src/components/constant/queryConstants";
import { useAppDispatch, useAppSelector } from "../store";
import CircularLoader from "src/components/UI/circularLoader/CircularLoader";
import { lazy, useCallback, useEffect, useMemo, useState } from "react";
import columns from "./groupConfig";
import { setColumnFilter } from "../filtersSlice";
import TableColumnFilter from "src/components/UI/tableColumnFIlter/TableColumnFilter";
import { fetchGroupListAction } from "./groupSlice";
import Modalui from "src/components/UI/modal/Modalui";
import { checkPermission } from "src/utils/utils";
import { CAN_CREATE_GROUP } from "src/components/constant/constant";
const AddGroup = lazy(() => import("src/components/groupComponent/addGroup/AddGroup"));

export default function () {
  const dispatch = useAppDispatch();
  const { group, loading } = useAppSelector((state) => state.group);
  const { column: columnFilter } = useAppSelector((state) => state.filters);
  const [searchParams, setSearchParams] = useSearchParams();
  const [addGroupModal, setAddGroupModal] = useState<boolean>(false);
  const limit = searchParams.get(LIMIT) ?? "10";
  const page = searchParams.get(PAGE) ?? "0";

  const fetchGroupList = useCallback(() => {
    const data = {
      size: Number(limit),
      from: Number(page) * Number(limit),
      filter: {}
    };

    dispatch(fetchGroupListAction(data));
  }, [page, limit, dispatch]);

  useEffect(() => {
    fetchGroupList();
  }, [fetchGroupList]);

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    searchParams.set(PAGE, String(newPage));
    setSearchParams(searchParams);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<{ value: unknown }>) => {
    searchParams.set(LIMIT, event.target.value as string);
    searchParams.set(PAGE, "0");
    setSearchParams(searchParams);
  };

  function closeAddGroupModal() {
    setAddGroupModal(false);
  }

  const filteredColumns = useMemo(() => {
    return columns.filter((col) => columnFilter?.group?.includes(col.key));
  }, [columnFilter?.group]);

  const handleColumnSelection = (selectedColumns: string[]) => {
    dispatch(
      setColumnFilter({
        plans: selectedColumns
      })
    );
  };

  return (
    <>
      <Modalui open={addGroupModal} handleClose={closeAddGroupModal} modaluiOver={styles.addGroupModaluiOver}>
        <AddGroup handleClose={closeAddGroupModal} onSuccess={fetchGroupList} />
      </Modalui>
      <div className={styles.wrapper}>
        <div className={styles.WelCard}>
          <TransactionWelCard heading={"View Your Groups"} subHeading={"View details of all the  group"} />
        </div>
        <div className={styles.list}>
          <div className={styles.listHead}>
            <div className={styles.listHeadIn}>
              <div className={styles.listHeadD}>
                <h3>Groups list</h3>
                <p>Manage all the groups</p>
              </div>
              <div className={styles.listHeadBtn}>
                {checkPermission(CAN_CREATE_GROUP) && (
                  <Button
                    variant="contained"
                    className={styles.createPlan}
                    onClick={() => setAddGroupModal(true)}
                    startIcon={<AddIcon fontSize="small" />}
                  >
                    Create Group
                  </Button>
                )}
                {/* <Button
                variant="contained"
                className={styles.filterBtn}
                //   onClick={() => setOpenFilterCard(true)}
              >
                Filters
              </Button> */}
              </div>
            </div>
            <div className={styles.listFilter}>
              {/* <div className={styles.filterTagsContainer}>
              {generateFilterTags(plansFilter).map((filterTag: FilterTagType) => (
                <FilterTag
                  key={filterTag.key}
                  tagKey={filterTag.key}
                  label={filterTag.label}
                  onRemove={() => removeTransactionFilter(filterTag.key)}
                />
              ))}
            </div> */}
              <TableColumnFilter
                columns={columns}
                selectedColumn={columnFilter?.group}
                mandatoryColumns={["group_id", "operations"]}
                onApply={handleColumnSelection}
                iconContanerClass={styles.tableColumnContainer}
              />
            </div>
          </div>
          <div className={styles.listTable}>
            <Table
              columns={filteredColumns}
              data={loading ? [] : group.list}
              className={styles.tableIn}
              // rowClassName={rowClassName}
              rowKey="id"
              components={
                loading
                  ? {
                      body: {
                        cell: CircularLoader
                      }
                    }
                  : undefined
              }
            />
          </div>
          <div className={styles.paginationWrapper}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={group.total ?? 0}
              page={parseInt(page)}
              onPageChange={handleChangePage}
              rowsPerPage={parseInt(limit)}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>
      </div>
    </>
  );
}
